const descriptions = {
  telemedicina: 'Colaboradora en una oficina durante una videoconsulta con una médica en pantalla',
  viajes: 'Avión de pasajeros en un aeropuerto',
  mascotas: 'Perro golden retriever',
  hogar: 'Casa con jardín',
  vehiculos: 'Automóvil circulando por una calle',
  'asistencia-medica': 'Doctora conversando con una paciente',
  comercio: 'Fachada de un comercio',
  empleados: 'Colaboradores reunidos en una oficina',
  expertos: 'Profesionales revisando documentos',
  digital: 'Computador portátil en un escritorio',
  funeraria: 'Flores blancas',
  dispositivos: 'Persona utilizando un teléfono móvil',
  electrodomesticos: 'Lavadora en un hogar',
  'proteccion-personal': 'Familia caminando al aire libre',
  tarjetas: 'Compra por internet con tarjeta',
};

export const CatalogPhoto = ({ category, compact = false }) => <img
  className={compact ? 'directory-filter-photo' : 'directory-group-photo'}
  src={`/images/catalog/${category === 'telemedicina' ? 'telemedicina-user-supplied' : category}.webp`}
  alt={compact ? '' : descriptions[category]}
  width="320" height="240" loading="lazy" decoding="async"
  data-testid={`${compact ? 'catalog-filter-photo' : 'catalog-photo'}-${category}`}
/>;